import { Box, Card, CardContent } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

export function CardSkeleton() {
    return (
        <div className="box-card">
            <Skeleton variant="rectangular" height={200} sx={{ margin: '1rem', borderRadius: '8px' }} />
        </div>
    );
}

export function CardSkeletonCollab() {
    return (
        <div className="bg-white rounded mt-2 w-100 d-flex flex-column">
            <Skeleton variant="rectangular" height={200} width={250} sx={{ margin: '1rem', borderRadius: '8px' }} />
            <Skeleton variant="rectangular" height={20} width={250} sx={{ margin: '0.2rem 1rem', borderRadius: '8px' }} />
            <Skeleton variant="rectangular" height={20} width={250} sx={{ margin: '0.2rem 1rem', borderRadius: '8px' }} />
            <Skeleton variant="rectangular" height={20} width={250} sx={{ margin: '0.2rem 1rem', borderRadius: '8px' }} />

        </div>
    );
}

export function CardSkeletonCount() {
    return (
        <div className="bg-white rounded mt-2 w-100 d-flex flex-column">
            <Skeleton variant="rectangular" height={100} width={250} sx={{ margin: '1rem', borderRadius: '8px' }} />

        </div>
    );
}

export function CardSkeletonCounts() {
    return (
        <div className="bg-white rounded mt-2 w-100 d-flex flex-column">
            <Skeleton variant="rectangular" height={100} width={150} sx={{ margin: '1rem', borderRadius: '8px' }} />

        </div>
    );
}

export function CardMediaSkeleton() {
    return (
        <div className="bg-white rounded mt-2 w-100 d-flex flex-column">
            <Card sx={{ borderRadius: "10px" }}>
                <CardContent>
                    <Skeleton variant="rectangular" height={60} />
                    <Skeleton variant="text" sx={{ mt: 2 }} />
                    <Skeleton variant="text" width="80%" />
                    <Skeleton variant="rounded" height={36} width="50%" sx={{ mt: 2 }} />
                </CardContent>
            </Card>
        </div>
    );
}

export function CompactCardSkeleton() {
    return (
        <div className="box-card">
            <Skeleton variant="rectangular" height={20} sx={{ margin: '1rem', borderRadius: '8px' }} />
        </div>
    );
}

export function TableSkeletonRows({ rows = 5 }) {
    return (
        <Box sx={{ paddingX: 2 , pt:2 }}>
            {[...Array(rows)].map((_, rowIndex) => (
                <Box key={rowIndex} sx={{ paddingY: 1 }}>
                    <Skeleton
                        variant="rectangular"
                        height={40}
                        width="100%"
                    />
                </Box>
            ))}
        </Box>
    );
}